module.exports = __webpack_public_path__ + "img/excel.f7b38f5f.svg";